// extracted by mini-css-extract-plugin
export default {"parent":"welcome_parent__fY40n","sidebar":"welcome_sidebar__OQSTS","welcome":"welcome_welcome__6I2O5"};